import { useRef } from "react";
import {
  FormGroup,
  ListGroup,
  ListGroupItem
} from "reactstrap";
import { Button } from "../Marketing/Button/Button";

const DEFAULT_MAX_SIZE_MB = 4.4;

const truncateFileName = (name, max = 20) => {
  if (name.length <= max) return name;
  return name.slice(0, max - 3) + "...";
};

const Attachments = ({
  attachments = [],
  setAttachments,
  maxSizeMB = DEFAULT_MAX_SIZE_MB,
  error = null,
  setError,
  label = "Attachment(s)",
  multiple = true,
  ...props
}) => {
  const fileInputRef = useRef(null);

  const handleAddFiles = (e) => {
    const files = Array.from(e.target.files);
    const newFiles = [];

    files.forEach((file) => {
      if (file.size > maxSizeMB * 1024 * 1024) {
        setError?.(`File '${file.name}' exceeds the ${maxSizeMB}MB limit.`);
        return;
      }

      if (attachments.some((a) => a.name === file.name)) {
        // Skip over attachment file if it has already been added. No duplicate names.
        return; 
      }

      newFiles.push(file);
    });

    if (newFiles.length) {
      setAttachments([...attachments, ...newFiles]);
      setError?.(null);
    }

    e.target.value = "";
  };

  const handleRemove = (idx) => {
    const newList = attachments.filter((_, i) => i !== idx);
    setAttachments(newList);
    setError?.(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleAttachClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  return (
    <FormGroup>
      {attachments.length > 0 && (
        <ListGroup
          style={{ border: "none", marginBottom: 4, maxWidth: "235px" }}
        >
          {attachments.map((file, idx) => (
            <ListGroupItem
              key={idx}
              className="d-flex justify-content-between align-items-center"
              style={{
                border: "none",
                padding: 0,
                background: "none",
              }}
            >
              <span className="lead">
                {truncateFileName(file.name)}{" "}
                <span className="text-muted">
                  ({(file.size / 1024 / 1024).toFixed(2)} MB)
                </span>
              </span>
              <span
                aria-label="Remove"
                onClick={() => handleRemove(idx)}
                style={{ color: "#dc3545", padding: 1, cursor: "pointer" }}
              >
                <i className="fas fa-trash" />
              </span>
            </ListGroupItem>
          ))}
        </ListGroup>
      )}
      {error && (
        <div className="mt-2 mb-2" style={{ color: "#dc3545" }}>
          {error}
        </div>
      )}
      <div className="d-flex align-items-center">
        <input
          type="file"
          name="attachments"
          id="attachments"
          style={{ display: "none" }}
          onChange={handleAddFiles}
          ref={fileInputRef}
          multiple={multiple}
          {...props}
        />
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={handleAttachClick}
        >
          Attach File(s)
        </Button>
      </div>
      <small>(Max File Size: {maxSizeMB}MB)</small>
    </FormGroup>
  );
};

export default Attachments;
